<template>
  <v-navigation-drawer
    v-model="drawerActive"
    fixed
    right
    hide-overlay
    :width="drawerWidth"
    clipped
    :style="`margin-top: ${$vuetify.application.top}px; border-top: 1px solid ${$vuetify.theme.dark ? '#414141' : 'gray'}; padding-bottom: ${$vuetify.application.top}px; z-index: 100;`"
    :class="'drawer-disable-scrollbar ' + drawerClass"
    stateless
  >
    <v-app-bar clipped-left clipped-right color="primary" dark flat>
      <span class="headline">{{ title }}</span>
      <div class="flex-grow-1"></div>
      <slot name="appBar"/>
      <v-btn icon >
        <v-icon @click="closeDrawer">fal fa-arrow-to-right</v-icon>
      </v-btn>
    </v-app-bar>
    <slot />
  </v-navigation-drawer>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'Drawer.vue',
  props: {
    drawerActive: {
      type: Boolean,
      default: false
    },
    title: String,
    closeDrawer: Function,
    drawerClass: {
      type: String,
      default: ''
    },
    drawerWidth: {
      type: String,
      default: '500px'
    }
  }
})
</script>

